/** 提交确认绑定安全项时的通用类型 */
export enum CommonConfirmSecurityAuthType {
  /** 未知 */
  UnKnow = 0,
  /** 绑定谷歌 */
  BindGoogle = 1,
  /** 换绑谷歌 */
  ChangeGoogle = 2,
  /** 绑定手机 */
  BindMobile = 3,
  /** 换绑手机 */
  ChangeMobile = 4,
  /** 绑定邮箱 */
  BindEmail = 5,
  /** 换绑邮箱 */
  ChangeEmail = 6,
  /** 绑定通行密钥 */
  BindPasskey = 7,
  /** 删除通行密钥 */
  DeletePasskey = 8,
  /** 开启谷歌 */
  OpenGoogle = 9,
  /** 关闭谷歌 */
  CloseGoogle = 10,
  /** 登录 */
  Login = 11,
  /** 修改登录密码 */
  ChangeLoginPwd = 12,
  /** 注销账号 */
  DeleteAccount = 13,
  /** 忘记密码 */
  ForgetPassword = 14,
  /** 提币 */
  Withdraw = 21,
  /** 开启支付二次验证 */
  OpenPayDoubleConfirm = 22,
  /** 关闭支付二次验证 */
  ClosePayDoubleConfirm = 23,
  /** 更新支付限额 */
  UpdatePayLimit = 26,
  /** 重置支付密码 */
  ResetPayPassword = 27,
  /** 删除设备通知 */
  RemoveDeviceNotify = 31,
  /** 关闭设备通知 */
  CloseDeviceNotify = 32,
  /** 查看卡信息 */
  CreditInfo = 41,
  /** 锁定卡/销卡 */
  CreditCardLock = 42,
  /** 解锁卡 */
  CreditCardUnlock = 43,
  /** 更新卡PIN码 */
  CreditCardUpdatePin = 44,
}
